<template>
	<div class='w-full aspect-[10/6] relative flex flex-col justify-between px-5'
		:class='{
			"bg-grey": !editing,
			"bg-black text-white": editing,
		}'
		ref='card'
	>
		<div class='flex justify-between pt-4'>
			<div class='flex'>
				<IconTrue class='stroke-white w-5 h-5 bg-green-600 rounded-full mr-2'
					v-if='editing' />
				<p class='text-12 xl:text-15 2xl:text-17'>{{ $help.capitalizeFirstLetter(paymentMethod.brand) }} {{ paymentMethod.funding }}</p>
			</div>

			<button class='underline text-12 xl:text-15 2xl:text-17'
				v-if='!view'
				@click='$emit("edit", paymentMethod)'>Edit</button>
		</div>

		<div class='flex'>
			<p class='text-24 xl:text-28 2xl:text-32 font-sub pt-1'>****</p>
			<p class='text-24 xl:text-28 2xl:text-32 font-hero pl-2'>{{ paymentMethod.last_4 }}</p>
		</div>

		<div class='flex justify-between pb-4'>
			<div class='w-14 h-[1.5vw] shrink-0' v-if='["visa", "mastercard", "amex"].indexOf(paymentMethod.brand) > -1'>
				<component :is='$icon.name(paymentMethod.brand)' :class='{
					"stroke-white fill-white": editing && paymentMethod.brand != "mastercard",
					"stroke-black fill-black": !editing && paymentMethod.brand != "mastercard",
				}'/>
			</div>
			<div class='text-14 xl:text-17'
				:class='{
					"text-grey-800": !editing,
					"text-white": editing,
				}'	
			>
				{{ paymentMethod.exp_month <= 9 ? '0' : '' }}{{ paymentMethod.exp_month }} / {{ String(paymentMethod.exp_year).slice(2, 4) }}
			</div>
			<div class='w-14 h-7'></div>
		</div>

		<div class='absolute bottom-0 right-0 flex items-start flex-col h-[60%] aspect-square'>
			<div class='flex h-2/2'>
				<div class='aspect-square' />
				<div class='rounded-tl-20 rounded-br-20 aspect-square'
					:class='{
						"bg-green-600": paymentMethod.brand == "mastercard",
						"bg-blue-600": paymentMethod.brand == "visa",
						"bg-red-600": paymentMethod.brand == "amex",
						"bg-grey-900": ["visa", "mastercard", "amex"].indexOf(paymentMethod.brand) == -1
					}'
				/>
			</div>
			<div class='flex h-2/2'>
				<div class='rounded-tl-20 rounded-br-20 aspect-square h-full' 
					:class='{
						"bg-green-400": paymentMethod.brand == "mastercard",
						"bg-blue-400": paymentMethod.brand == "visa",
						"bg-red-400": paymentMethod.brand == "amex",
						"bg-grey-700": ["visa", "mastercard", "amex"].indexOf(paymentMethod.brand) == -1
					}'
				/>
				<div class='rounded-tr-20 aspect-square h-full flex items-center justify-center'
					:class='{
						"bg-green-500": paymentMethod.brand == "mastercard",
						"bg-blue-500": paymentMethod.brand == "visa",
						"bg-red-500": paymentMethod.brand == "amex",
						"bg-grey-800": ["visa", "mastercard", "amex"].indexOf(paymentMethod.brand) == -1
					}'
				>
					<IconTrue class='stroke-white w-5 h-5 bg-black rounded-full'
						v-if='paymentMethod.default_payment_method != null' />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			paymentMethod: Object,
			view: {
				type: Boolean,
				default: true
			},
			editing: {
				type: Boolean,
				default: false
			}
		},

		computed: {

		}
	}
</script>